<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <div class="main-question">
            <div class="question-header">
              <h3 class="title">
                <div class="item">
                  문의 등록
                </div>
              </h3>
            </div>
            <div class="question-write">
              <div class="body">
                <!-- 필수 : required -->
                <div class="field type required">
                  <div class="caption">
                    유형
                  </div>
                  <div class="content">
                    <div class="contain">
                      <div class="item select">
                        <div class="formSelect" ref="select01" @click="openSelect01">
                          <div class="formSelectList">
                            <input :value="selectedType.value" type="text" placeholder="유형을 선택하세요." readonly />
                          </div>
                          <div class="formSelectPopup select01">
                            <div class="formSelectPopup-container">
                              <div class="outer">
                                <div class="inner">
                                  <div class="formSelectPopup-box">
                                    <div class="formSelectPopup-zone">
                                      <div class="formSelectPopup-header">
                                        <input type="text" placeholder="유형을 선택하세요." />
                                      </div>
                                      <ul class="formSelectPopup-body">
                                        <li v-for="type in typeList" :key="type.key">
                                          <label>
                                            <input type="radio" v-model="selectType" :value="type.key"/>
                                            <input type="checkbox" />
                                            <i></i>
                                            <span>{{ type.value }}</span>
                                          </label>
                                        </li>
                                      </ul>
                                      <div class="formSelectPopup-footer">
                                        <button class="formSelectPopup-cancel">
                                          취소
                                        </button>
                                        <!-- 비활성(Attribute) : disabled -->
                                        <button class="formSelectPopup-confirm">
                                          확인
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 필수 : required -->
                <div class="field title required">
                  <div class="caption">
                    제목
                  </div>
                  <div class="content">
                    <div class="contain">
                      <div class="item input">
                        <input type="text" placeholder="제목을 입력하세요." v-model="title"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field write">
                  <textarea placeholder="내용을 입력하세요." v-model="content"></textarea>
                </div>
              </div>
            </div>
            <div class="question-button">
              <button class="cancel" @click="moveMenu('/CS101')">
                취소
              </button>
              <!-- 비활성(Attribute) : disabled -->
              <button class="registration" @click="postData" :disabled="!passValidation">
                등록
              </button>
            </div>
          </div>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="alert typeConfirm">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body" v-html="alertMessage">
                  </div>
                  <div class="footer">
                    <button class="cancel">
                      취소
                    </button>
                    <button class="confirm" @click="confirmAlert">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div><div class="formSelectPopup select01">
      <div class="formSelectPopup-container">
        <div class="outer">
          <div class="inner">
            <div class="formSelectPopup-box">
              <div class="formSelectPopup-zone" ref="m_select01" @click="openSelect01">
                <div class="formSelectPopup-header">
                  <input type="text" placeholder="유형을 선택하세요." />
                </div>
                <ul class="formSelectPopup-body">
                  <li v-for="type in typeList" :key="type.key">
                    <label>
                      <input type="radio" v-model="selectType" :value="type.key"/>
                      <input type="checkbox" />
                      <i></i>
                      <span>{{ type.value }}</span>
                    </label>
                  </li>
                </ul>
                <div class="formSelectPopup-footer">
                  <button class="formSelectPopup-cancel">
                    취소
                  </button>
                  <!-- 비활성(Attribute) : disabled -->
                  <button class="formSelectPopup-confirm">
                    확인
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'
import {csService, settingService} from '../../router'

export default {
  name: 'CS103',
  data () {
    return {
      selectType: '',
      typeList: [
        {
          key: 'service',
          value: '서비스',
          template: '디바이스: PC / 모바일 \n'
        },
        {
          key: 'event',
          value: '이벤트',
          template: '이벤트 내용: \n'
        },
        {
          key: 'update',
          value: '업데이트',
          template: '업데이트 버전: \n'
        }
      ],
      title: '',
      content: '',
      alertBodyHTML: '',
      callback: null
    }
  },
  created: function () {
  },
  mounted: function () {
    this.setData()
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  methods: {
    setData: function () {
    },
    setTextareaTemplate: function () {
      this.content = this.selectedType.template
    },
    postData: function () {
      csService.postInquire(this.selectType, this.title, this.content).then(response => {
        if (response.statusCode === 200) {
          settingService.insertPushAlarm({
            funcId: '6',
            pageId: 'CS-103',
            message: this.userInfo.userName,
            pageQuery: `?inquire_id=${response.data.inquireId}`
          }).then(() => {
            this.openAlert('문의사항이 등록되었습니다.', '/CS102?inquire_id=' + response.data.inquireId)
          })
        } else if (response.statusCode !== 200) {
          this.openAlert('글 등록에 실패했습니다.<br>다시 시도해주세요.', null)
        }
      }).catch(error => {
        console.log('getClubInfoListByStatusActive.err.===>', error)
      })
    }
  },
  computed: {
    selectedType: function () {
      if (this.typeList.find(it => it.key === this.selectType) === undefined) return {}
      return this.typeList.find(it => it.key === this.selectType)
    },
    passValidation: function () {
      if (!this.title) return false
      if (!this.selectType) return false
      if (!this.content) return false
      return true
    }
  },
  watch: {
    selectType: function () {
      this.setTextareaTemplate()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cs/CS103.vue